module.exports = __webpack_public_path__ + "media/packs/images/overnight-test-be1475676de71b06a5165f8810bc071f.png";